module.exports = __webpack_public_path__ + "img/MC-Logo-Color.aafca1c.png";